
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const contractApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listContracts: builder.query ({
      query: (params) => `v2/contract/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Contract"]
    }),
    getContract: builder.query ({
      query: (contract_id) => `v2/contract/${contract_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Contract"]
    }),

    updateContract: builder.mutation ({
      query: ({contract_id, data}) => ({
        url: `v2/contract/${contract_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Contract"]
    }),
    deleteContract: builder.mutation ({
      query: (contract_id) => ({
        url: `v2/contract/${contract_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Contract"]
    }),
    createContract: builder.mutation ({
      query: (data) => ({
        url: `v2/contract/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Contract"]
    }),
  })
})


export const {
  useListContractsQuery,
  useLazyListContractsQuery,
  useGetContractQuery,
  useLazyGetContractQuery,

  useUpdateContractMutation,
  useDeleteContractMutation,
  useCreateContractMutation
} = contractApi
